import { Link } from "react-router-dom";

/**
 * "Pickups · Re-recording guide" — the two ways to read the same package. The
 * Pickups Package lists every difference; the guide groups them into the
 * passages to record again. Both tick the same pickups.
 */
export function GuideTabs({ active, pickupsTo, guideTo }: {
  active: "pickups" | "guide";
  pickupsTo: string;
  guideTo: string;
}) {
  return (
    <nav className="rrg-tabs" aria-label="View">
      <Link to={pickupsTo} className={active === "pickups" ? "on" : ""} aria-current={active === "pickups" ? "page" : undefined}>
        Pickups
      </Link>
      <Link to={guideTo} className={active === "guide" ? "on" : ""} aria-current={active === "guide" ? "page" : undefined}>
        Re-recording guide
      </Link>
    </nav>
  );
}
